// Consolidation-risk flag category labels + helpers (source of truth for the
// UI-facing names: PROD/2907373590). The FlagCategory/FlagSeverity unions live
// in types/flags.ts so shared type files don't depend on this component folder;
// this module imports FlagCategory back and asserts the label array covers it.

import type { FlagCategory } from 'types/flags';

export const FLAG_CATEGORIES: readonly {
  value: FlagCategory;
  label: string;
}[] = [
  { value: 'repeated_base_name', label: 'Repeated Base Name' },
  { value: 'life_tenant', label: 'Life Tenant' },
  { value: 'name_trustee', label: 'Name, Trustee' },
  { value: 'doc_reference', label: 'Doc Reference' },
  { value: 'specified_interest', label: 'Specified Interest' },
  {
    value: 'marital_property_designation',
    label: 'Marital Property Designation',
  },
  { value: 'mers_nominee', label: 'MERS Nominee' },
  { value: 'via_from_reference', label: 'Via/From Reference' },
  { value: 'other_user', label: 'Other/User' },
];

export const OTHER_USER: FlagCategory = 'other_user';

export const flagCategoryLabel = (value: string | null | undefined): string =>
  FLAG_CATEGORIES.find((c) => c.value === value)?.label ?? '';
